import React from 'react';

function AIPredictionCard({ prediction, onViewDetails }) {
  const getPerformanceColor = (performance) => {
    switch(performance) {
      case 'Excellent': return 'success';
      case 'Good': return 'info';
      case 'Average': return 'warning';
      case 'Poor': return 'danger';
      default: return 'secondary';
    }
  };

  return (
    <div className="card h-100">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
            <h6 className="font-weight-bold text-primary">{prediction.childName}</h6>
            <small className="text-muted">
              Generated: {new Date(prediction.generatedAt).toLocaleDateString()}
            </small>
          </div>
          <span className={`badge bg-${getPerformanceColor(prediction.predictedPerformance)}`}>
            {prediction.predictedPerformance}
          </span>
        </div>
        
        <div className="mb-3">
          <p className="mb-2">
            <strong>Confidence:</strong> {prediction.confidenceScore}%
          </p>
          <div className="progress" style={{height: '8px'}}>
            <div 
              className="progress-bar bg-success" 
              role="progressbar" 
              style={{width: `${prediction.confidenceScore}%`}}
            ></div>
          </div>
        </div>
        
        {prediction.strengths && prediction.strengths.length > 0 && (
          <div className="mb-3">
            <strong>Strengths:</strong>
            <ul className="list-unstyled mb-0">
              {prediction.strengths.slice(0, 2).map((strength, i) => (
                <li key={i} className="text-success">
                  <i className="fas fa-check-circle me-1"></i> {strength}
                </li>
              ))}
            </ul>
          </div>
        )}
        
        {prediction.recommendations && prediction.recommendations.length > 0 && (
          <div className="mb-3">
            <strong>Recommendations:</strong>
            <ul className="list-unstyled mb-0">
              {prediction.recommendations.slice(0, 2).map((rec, i) => (
                <li key={i}>
                  <i className="fas fa-lightbulb me-1 text-warning"></i> {rec}
                </li>
              ))}
            </ul>
          </div>
        )}
        
        {onViewDetails && (
          <button 
            className="btn btn-outline-dark btn-sm w-100 mt-2"
            onClick={onViewDetails}
          >
            View Full Analysis
          </button>
        )}
      </div>
    </div>
  );
}

export default AIPredictionCard;